<template>
  <panel-section
      class="ai-visibility-competitor-panel"
      :title="title"
      :subtitle="subtitle"
      card-class="ai-visibility-competitor-panel__card"
  >
    <div class="ai-visibility-competitor-panel__table" role="table">
      <div class="ai-visibility-competitor-panel__header-row" role="row">
        <span role="columnheader">Competitor</span>
        <span role="columnheader">Visibility score</span>
      </div>
      <competitor-score-row
          v-for="row in competitors.rows"
          :key="row.id"
          :row="row"
      />
    </div>
    <panel-action-link
        class="ai-visibility-competitor-panel__action"
        :to="actionTo"
        @click="$emit('view-all')"
    >
      {{ actionLabel }}
    </panel-action-link>
  </panel-section>
</template>

<script>
import PanelActionLink from '../../../ui/cards/PanelActionLink.vue'
import PanelSection from '../../../ui/cards/PanelSection.vue'
import CompetitorScoreRow from './CompetitorScoreRow.vue'

export default {
  name: 'CompetitorScorePanel',
  components: {
    PanelActionLink,
    PanelSection,
    CompetitorScoreRow,
  },
  props: {
    title: {
      type: String,
      default: 'Who else AI is talking about',
    },
    subtitle: {
      type: String,
      default: '',
    },
    competitors: {
      type: Object,
      default: function () {
        return {
          rows: [],
          total: 0
        }
      }
    },
    actionTo: {
      type: [Object, String],
      default: null,
    }
  },
  computed: {
    actionLabel () {
      return `See all ${this.competitors.total} competitors`
    }
  }
}
</script>

<style lang="scss" scoped>

.ai-visibility-competitor-panel {
  min-height: 390px;
}

.ai-visibility-competitor-panel__card {
  min-height: 340px;
}

.ai-visibility-competitor-panel__table {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ai-visibility-competitor-panel__header-row {
  display: grid;
  grid-template-columns: minmax(120px, 1fr) minmax(150px, 230px) 38px;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
}

.ai-visibility-competitor-panel__header-row span {
  color: var(--v-mainColor3-base);
  font-size: 16px;
  font-weight: 700;
}

.ai-visibility-competitor-panel__header-row span:last-child {
  grid-column: 2 / 4;
  text-align: right;
}

.ai-visibility-competitor-panel__action {
  margin-top: 16px;
}

@media (max-width: 520px) {
  .ai-visibility-competitor-panel__header-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .ai-visibility-competitor-panel__header-row span:last-child {
    grid-column: 2;
  }
}
</style>
